exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2cExz790o9g39SOzo95WOU h1{margin-bottom:10px}._2cExz790o9g39SOzo95WOU h2{font-size:18px;line-height:22px;font-weight:bold;margin-bottom:20px}._2cExz790o9g39SOzo95WOU hr{margin-top:30px;margin-bottom:30px}._2cExz790o9g39SOzo95WOU ul{margin-top:0}._2cExz790o9g39SOzo95WOU ._2DGg240QMsfrr3fWVAgOhu{font-weight:500;font-size:13px}._2cExz790o9g39SOzo95WOU ._1BeRwvEhHmPgkup4IUufAd{display:flex;justify-content:space-between;cursor:pointer}._2cExz790o9g39SOzo95WOU ._1BeRwvEhHmPgkup4IUufAd ._39I4HJhDQy1EsJefGx_kO0{color:#9e9e9e}\n", ""]);

// Exports
exports.locals = {
	"Faq": "_2cExz790o9g39SOzo95WOU",
	"contactUsLink": "_2DGg240QMsfrr3fWVAgOhu",
	"itemHeader": "_1BeRwvEhHmPgkup4IUufAd",
	"icon": "_39I4HJhDQy1EsJefGx_kO0"
};